// src/pages/clientes/ClienteDetallePage.tsx
import { useParams } from 'react-router-dom';
import { Tabs, TabsContent, TabsList, TabsTrigger, PageLoader } from '@/components/ui';
import { useCliente } from '@/hooks/queries/useClientes';
import { ClienteInfo } from './components/ClienteInfo';
import { EmpresasTab } from './components/EmpresasTab';
import { ContactosTab } from './components/ContactosTab';
import { Building2, Users, Ticket, MessageSquare } from 'lucide-react';

export function ClienteDetallePage() {
  const { id } = useParams<{ id: string }>();
  const { data: cliente, isLoading, error } = useCliente(id);

  if (isLoading) {
    return <PageLoader message="Cargando cliente..." />;
  }

  if (error || !cliente) {
    return (
      <div className="flex items-center justify-center h-full">
        <div className="text-center">
          <h2 className="text-xl font-semibold text-gray-900">Cliente no encontrado</h2>
          <p className="text-gray-500 mt-2">
            El cliente solicitado no existe o fue eliminado
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <ClienteInfo cliente={cliente} />

      <Tabs defaultValue="empresas">
        <TabsList>
          <TabsTrigger value="empresas" className="flex items-center gap-2">
            <Building2 className="h-4 w-4" />
            Empresas
          </TabsTrigger>
          <TabsTrigger value="contactos" className="flex items-center gap-2">
            <Users className="h-4 w-4" />
            Contactos
          </TabsTrigger>
          <TabsTrigger value="tickets" className="flex items-center gap-2">
            <Ticket className="h-4 w-4" />
            Tickets
          </TabsTrigger>
          <TabsTrigger value="conversaciones" className="flex items-center gap-2">
            <MessageSquare className="h-4 w-4" />
            Conversaciones
          </TabsTrigger>
        </TabsList>

        <TabsContent value="empresas">
          <EmpresasTab clienteId={cliente.id} />
        </TabsContent>

        <TabsContent value="contactos">
          <ContactosTab clienteId={cliente.id} />
        </TabsContent>

        <TabsContent value="tickets">
          <div className="mt-4 p-8 text-center text-gray-500 border rounded-lg">
            Los tickets del cliente se mostrarán aquí cuando se implemente el módulo FE
          </div>
        </TabsContent>

        <TabsContent value="conversaciones">
          <div className="mt-4 p-8 text-center text-gray-500 border rounded-lg">
            Las conversaciones del cliente se mostrarán aquí cuando se implemente el módulo FD
          </div>
        </TabsContent>
      </Tabs>
    </div>
  );
}

export default ClienteDetallePage;
